import EducationTable from "./EducationTable";
import { Wrapper } from "../Style";

function Education() {
  return (
    <Wrapper>
      <EducationTable />
    </Wrapper>
  );
}

export default Education;
